import useSWR from 'swr'
import { useParams } from 'react-router-dom'
import { MULTIMAXI_REFRESH_INTERVAL } from '../constants'
import { filterLinesBefore } from '../containers/PassagesUtils'
import { getMultivertrekken as getMultivertrekkenTravelinfoTrip } from '../data/travelinfoTrip.api'
import { isRealtimeError } from '../helpers/debugOptions'

const DEFAULT_LINE_COUNT = '10'

const fetcher = async ({ haltenummers, aantal }) => {
  if (isRealtimeError()) {
    console.log('Fake realtime error')
    throw new Error('RTKN debug error for realtime calls')
  }
  return getMultivertrekkenTravelinfoTrip({ haltenummers, aantal })
}

export function useMultivertrekken({ stopIds } = {}) {
  const { haltenummers, aantal = DEFAULT_LINE_COUNT } = useParams()

  const { data, error, isLoading } = useSWR(
    `multimaxi-${stopIds ?? haltenummers}`,
    (key) => fetcher({ key, haltenummers: stopIds ?? haltenummers, aantal }),
    {
      refreshInterval: MULTIMAXI_REFRESH_INTERVAL,
      fallbackData: {
        lijnen: [],
      },
      revalidateOnFocus: false,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        const errorTimeoutId = setTimeout(() => {
          revalidate({ retryCount })
          clearTimeout(errorTimeoutId)
        }, MULTIMAXI_REFRESH_INTERVAL)
      },
    },
  )

  if (error) {
    return {
      passages: {
        ...data,
        lijnen: filterLinesBefore(data?.lijnen || [], Date.now()),
      },
      error,
      isLoading,
    }
  }

  return {
    passages: {
      ...data,
    },
    error,
    isLoading,
  }
}
